import React, { FC, useState } from "react"
import { observer } from "mobx-react"
import { Tabs, Spin } from "antd"
import { useStore } from "stores/utils/use-store"
import { FormulasTab } from "./formulas-tab"
import { GameModeMultipliersTab } from "./game-mode-multipliers-tab"

const { TabPane } = Tabs

export const RewardFormulasPage: FC = observer(() => {
  const { dataStore: { formulasStore, gameModeMultipliersStore } } = useStore()
  const [activeTab, setActiveTab] = useState<string>("formulas")

  return (
    <Spin spinning={formulasStore.isLoading || gameModeMultipliersStore.isLoading} size="large">
      <Tabs
        style={{ marginBottom: "20px" }}
        activeKey={activeTab}
        onChange={setActiveTab}
      >
        <TabPane tab="Formulas" key="formulas">
          <FormulasTab />
        </TabPane>
        <TabPane tab="Game Mode Multipliers" key="game-mode-multiplier">
          <GameModeMultipliersTab />
        </TabPane>
      </Tabs>
    </Spin>
  )
})
